module.exports = __webpack_public_path__ + "img/Macabi.babee32b.svg";